const slides = [
  {
    img: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20banner%20design%20with%20warm%20golden%20sunset%20horizon%20and%20heroic%20silhouette%20standing%20on%20mountain%20peak%2C%20dramatic%20clouds%20illuminated%20by%20amber%20light%2C%20film%20grain%20texture%20and%20professional%20color%20grading%2C%20blockbuster%20movie%20promotional%20banner%20aesthetic%2C%20grand%20epic%20scale%20composition&width=1200&height=500&seq=carousel-slide-01&orientation=landscape',
    tag: '重磅推荐',
    title: '《暗夜追击》— 年度动作巨制震撼上线',
    desc: '硬汉归来，极限追凶，全程高能无尿点',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20noir%20banner%20with%20rainy%20city%20street%20at%20night%20reflected%20in%20puddles%2C%20neon%20signs%20casting%20colorful%20reflections%2C%20lone%20detective%20figure%20in%20trench%20coat%2C%20suspenseful%20thriller%20atmosphere%2C%20cinematic%20promotional%20banner%20design%20with%20dark%20teal%20and%20amber%20color%20scheme%2C%20film%20noir%20visual%20style&width=1200&height=500&seq=carousel-slide-02&orientation=landscape',
    tag: '悬疑专场',
    title: '《无声证词》— 烧脑悬疑全程高能反转',
    desc: '线索交织，真相层层揭开，挑战你的推理极限',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20animation%20banner%20with%20magical%20floating%20islands%20and%20colorful%20aurora%20sky%2C%20whimsical%20storybook%20aesthetic%20with%20sparkling%20particles%20and%20soft%20glowing%20elements%2C%20vibrant%20warm%20color%20palette%2C%20animated%20film%20promotional%20visual%2C%20enchanting%20dreamlike%20atmosphere%20with%20professional%20design%20quality&width=1200&height=500&seq=carousel-slide-03&orientation=landscape',
    tag: '亲子首选',
    title: '《梦境奇旅》— 暑期奇幻冒险感动上映',
    desc: '豆瓣9.5分，大人小孩都爱的年度动画神作',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Romantic%20cinematic%20banner%20with%20couple%20silhouette%20under%20starry%20night%20sky%2C%20soft%20golden%20moonlight%20and%20twinkling%20stars%2C%20dreamy%20bokeh%20effect%20in%20warm%20tones%2C%20nostalgic%20film%20photography%20aesthetic%2C%20romantic%20movie%20promotional%20banner%20design%2C%20tender%20atmospheric%20visual%20storytelling&width=1200&height=500&seq=carousel-slide-04&orientation=landscape',
    tag: '口碑佳作',
    title: '《那年星空下》— 纯爱回归温暖每一颗心',
    desc: '跨越十年的约定，年度最催泪爱情故事',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20banner%20with%20massive%20spaceship%20approaching%20colorful%20nebula%2C%20distant%20planets%20and%20star%20fields%2C%20epic%20cosmic%20scale%20composition%20with%20lens%20flare%20effects%2C%20grand%20science%20fiction%20movie%20visual%20style%2C%20professional%20promotional%20banner%20design%20with%20deep%20space%20atmosphere&width=1200&height=500&seq=carousel-slide-05&orientation=landscape',
    tag: '科幻盛宴',
    title: '《星际迷途》— 探索无垠宇宙的终极奥秘',
    desc: '顶级视效打造震撼太空之旅，4K HDR沉浸体验',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary-400 mb-3">SPOTLIGHT</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">专题推荐</h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-[500px] mx-auto">编辑团队精选的优质影视专题，每一部都值得细细品味</p>
          </div>

          <div className="flex flex-col gap-5">
            {slides.map((s, i) => (
              <div key={i} className="group relative rounded-2xl overflow-hidden border border-background-200/40 hover:border-primary-500/20 transition-all duration-300 cursor-pointer">
                <div className="relative aspect-[21/9] md:aspect-[24/9] overflow-hidden">
                  <img
                    src={s.img}
                    alt={s.title}
                    className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-background-50/85 via-background-50/40 to-transparent"></div>
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 via-transparent to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10">
                    <span className="inline-block text-xs px-3 py-1 rounded-full bg-primary-500/90 text-background-50 font-medium mb-3 whitespace-nowrap">
                      {s.tag}
                    </span>
                    <h3 className="text-lg md:text-2xl font-heading font-bold text-foreground-50 mb-2">{s.title}</h3>
                    <p className="text-sm md:text-base text-foreground-300">{s.desc}</p>
                    <div className="flex items-center gap-3 mt-5">
                      <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap">
                        <i className="ri-play-fill"></i>
                        立即观看
                      </div>
                      <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-200/60 hover:bg-background-300/60 text-foreground-200 font-medium text-sm border border-background-300/40 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                        <i className="ri-information-line"></i>
                        了解详情
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}